<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 485.7 485.7" xml:space="preserve" width="100%" height="100%">
        <path style="fill:none;stroke:currentColor;stroke-width:15;stroke-miterlimit:10;" d="M20.4,319.3c17.9,22.9,87.7,27.5,129.1-34.7s59.8-124.2,53.9-169.6s-40.9-36.6-44.8,34.5
        s112.6,161.5,112.6,211.9s-62.8,48.8-62.8,2.4S350.7,233.8,361,145.2c8.3-71.5-51.1-73.2-49.1,17.7s26.4,143.9,71.8,165.4
        c38,18,71.7,3.4,82.6-11.5"/>
        <path style="fill:none;stroke:currentColor;stroke-width:15;stroke-miterlimit:10;" d="M478.2,242.8c0,130-105.4,235.3-235.3,235.3S7.5,372.8,7.5,242.8S112.9,7.5,242.8,7.5
        S478.2,112.9,478.2,242.8z"/>
    </svg>
</template>